import { render, staticRenderFns } from "./TreasuriesTable.vue?vue&type=template&id=6bfecc38&"
import script from "./TreasuriesTable.vue?vue&type=script&lang=js&"
export * from "./TreasuriesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports